/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Embed_Captions_Confirm_Job_CountInputs */



/**
* | output |
* | --- |
* | "{count} separate embed jobs will be submitted, one for each video." |
*
* @param {Embed_Captions_Confirm_Job_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_job_count = /** @type {((inputs: Embed_Captions_Confirm_Job_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_Job_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} tâches d'intégration distinctes seront soumises, une par vidéo.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Es werden ${i?.count} separate Einbettungsjobs eingereicht, einer pro Video.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Verranno inviati ${i?.count} lavori di incorporamento separati, uno per ogni video.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Будет отправлено отдельных заданий на встраивание: ${i?.count}, по одному на каждое видео.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se enviarán ${i?.count} trabajos de incrustación independientes, uno por cada video.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`将提交 ${i?.count} 个单独的嵌入任务，每个视频一个。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`動画ごとに1つずつ、${i?.count} 件の個別の埋め込みジョブが送信されます。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} अलग-अलग एम्बेड जॉब सबमिट किए जाएँगे, प्रत्येक वीडियो के लिए एक।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Serão enviados ${i?.count} trabalhos de incorporação separados, um por cada vídeo.`)
	return /** @type {LocalizedString} */ (`${i?.count} separate embed jobs will be submitted, one for each video.`)
});